import React from 'react'
import Header from '../components/Header/Header';
import Dotgrid from '../components/Dotgrid/Dotgrid';

const Head = () => {
  return <section className="section-wrapper hero_hero__HQvTb">
    <Header />
    <Dotgrid/>
  </section>;
}

export default Head